export class NumberValidators {
  public static isNumeric(c): any {
    if (!isNaN(parseFloat(c.value)) && isFinite(c.value)) {
      return null;
    } else {
      return {
        notNumeric: true
      };
    }
  }

  public static onlyTwoDecimals(c): any {
    const regexp = /^\d+(\.\d{1,2})?$/;
    if (regexp.test(c.value)) {
      return null;
    } else {
      return {
        patternInvalid: true
      };
    }
  }

  public static greaterThanZero(c): any {
    if (parseFloat(c.value) > 0) {
      return null;
    } else {
      return {
        lessThanZero: true
      };
    }
  }

  public static isPositive(c): any {
    if (parseFloat(c.value) >= 0) {
      return null;
    } else {
      return {
        isNegative: true
      };
    }
  }

  public static lessThan(max: number) {
    const maxNumber = max;
    return (control): { [key: string]: any } => {
      const num = +control.value;
      if (isNaN(num) || num > maxNumber) {
        return {
          isGreater: true
        };
      }
      return null;
    };
  }

  public static greaterThan(min: number) {
    const minNumber = min;
    return (control): { [key: string]: any } => {
      const num = +control.value;
      if (isNaN(num) || num < minNumber) {
        return {
          isLess: true
        };
      }
      return null;
    };
  }
}
